import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, Output, NgZone, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PanelList } from '../../../../shared/models/panel-list';
import { SpeedDialMenu } from '../../../../shared/models/speed-dial-menu';
import { ActionPlanService } from '../../services/action-plan.service';
import { CommonService } from '../../../../shared/services/common.service';
import { ActionPlanDetails } from '../../models/action-plan-details';
import { ActionItemAttachmentDetails } from '../../models/action-item-attachment-details';
import { ActionItemConstants } from '../../constants/action-item-constants';
import { ActionItemDetails } from '../../models/action-item-details';
import { ActionItemLifeCycleModalValues } from '../../models/action-item-life-cycle-modal-values';
import { ActionItemModal, LabelMap } from '../common/action-item-life-cycle-modal';
import { ChangeControlPersistenceService } from '../../services/change-control-persistence.service';
import { SpinnerService } from '../../../../shared/services/spinner.service';

@Component({
  selector: 'app-action-plan',
  templateUrl: './action-plan.component.html',
  styleUrls: ['./action-plan.component.scss']
})
export class ActionPlanComponent {
  @Input() changeControlNumber: string = '';
  @Input() isAddButtonVisible : boolean = false;
  @Input() scopes : number[] = [];
  @Input() selectCheckbox = false;
  @Output() checkboxSelection = new EventEmitter();
  @Output() selectedItems = new EventEmitter();
  isActionItemSliderOpen = false;
  showLoader : boolean = false;
  actionItemLifeCycleModalValues!: ActionItemLifeCycleModalValues;
  event: string = "";
  isUpdateActionItemModalOpen: boolean = false;
  actionItemData!: ActionItemDetails;
  actionItemNumberForAudit : string = '';
  showActionItemAuditModal : boolean = false;
  loading = signal(false);
  isActionPlanDataAvailable : boolean = false;
  noData : boolean = false;
  speedDialOptions! : SpeedDialMenu[];
  actionItemAttachments!: ActionItemAttachmentDetails[] | null;
  attachmentsAvailable: boolean = false;
  eventType: string = '';
  preFilledReason = ''; // for modal popup data for Phase Change
  lastActionItemNumber ?: string;

  ActionPlanData : PanelList={
    lists:[],
    filters:[],
    sort:[],
    enableSelection: true,
    enableFilter: true,
    enableSort: true,
  };


  getSelectedItems(selectedItemsData: ActionItemDetails[]) {
    this.selectedItems.emit(selectedItemsData);
  }

  constructor(private actionPlanService: ActionPlanService, private commonService: CommonService, 
    public datepipe: DatePipe, private injector: Injector, private changecontrolPersistenceService: ChangeControlPersistenceService,
    private changeDetectorRef: ChangeDetectorRef, private spinnerService: SpinnerService) {}
  
  ngOnInit(){
    this.getActionPlan();  
    this.ActionPlanData.lists.title="Panel List";
    
    // To Reload Action Plan data
    this.changecontrolPersistenceService.updateInActionPlanData()
      .subscribe((isUpdated : boolean) => this.ActionPlanDataReload(isUpdated)); 
      
      this.changecontrolPersistenceService.updateScopesOnChangeControlUpdate()
        .subscribe((scopes : number[] | null) => this.updateScopesOnChangeControlUpdate(scopes));
  };

  openActionItemSlider() {
    this.isActionItemSliderOpen = !this.isActionItemSliderOpen;
  }

  closeSlider(value : boolean) {
    this.event = ''; // reset event name as its closed
    this.isActionItemSliderOpen = value;
    this.actionItemData = new ActionItemDetails;
  }

  closeActionItemSlider() {
    this.isActionItemSliderOpen = false;
  }

  ActionPlanDataReload(event:any){
    this.getActionPlanData(event)
  }

  getActionPlanData(isRefresh: boolean) {
    if (isRefresh) {
      setTimeout(() => {
        this.getActionPlan();
      }, 2000);
    }
  }

  getActionPlan(){  
    this.loading.set(true);
    this.actionPlanService.getActionPlanForCC(this.changeControlNumber).
     subscribe(
      data => {       
        if(data!=null)
        {
          this.ActionPlanData.lists =  data?.actionItemDetails;
          const actionItemNumbers = data?.actionItemDetails?.map((item: ActionItemDetails) => item.actionItemNumber);
          this.lastActionItemNumber = actionItemNumbers.sort((a : string, b : string) => {
            const getLastSegment = (str: string) => parseInt(str.split('-').pop() || '0', 10);
            return getLastSegment(b) - getLastSegment(a); // Descending sort
          })[0];
          this.noData = this.commonService.IsListEmpty(this.ActionPlanData.lists);
          this.SetSelectedItems();
        }
        this.isActionPlanDataAvailable = true;
        this.loading.set(false);
      },
      err => {
        this.loading.set(false);
        console.log("Error While fetching Action plan or no ACtion Plan Present for this Change Control.");
    }); 
  }

  SetSelectedItems(){
    this.addFilters();
    this.addSorting();
    this.isActionPlanDataAvailable = true;
    this.ActionPlanData={...this.ActionPlanData};
  }

  addFilters():void{
    this.ActionPlanData.filters = [];
    this.ActionPlanData.enableFilter=true;
    this.ActionPlanData.filters?.push(    
    {
      filterDisplayName:"Status",
      filterFieldName:"statusName",
    });
    this.ActionPlanData.filters?.push(    
    {
      filterDisplayName:"Assigned User",
      filterFieldName:"assignedUser",
    });
    this.ActionPlanData.filters?.push(    
    {
      filterDisplayName:"Verifier",
      filterFieldName:"verifier",
    }); 
    this.ActionPlanData.filters?.push(    
    {
      filterDisplayName:"Type",
      filterFieldName:"actionTypeName",
    }); 
  }

  addSorting():void{
    this.ActionPlanData.sort = [];
    this.ActionPlanData.enableSort=true;
    this.ActionPlanData.sort?.push(
      {
        sortFieldDisplayName:"Status",
        sortFieldName:"status"
      }
    );
    this.ActionPlanData.sort?.push(
      {
        sortFieldDisplayName:"Assigned User",
        sortFieldName:"assinedUser"
      }
    );
    this.ActionPlanData.sort?.push(
      {
        sortFieldDisplayName:"Verifier",
        sortFieldName:"verifier"
      }
    );
    this.ActionPlanData.sort?.push(
      {
        sortFieldDisplayName:"Type",
        sortFieldName:"actionType"
      }
    );
  }

  // On Click of attachment button - we call this function to load modal and update input parameter data
  OpenActionItemAttachmentModal(attachment : ActionItemAttachmentDetails[])
  {
    this.attachmentsAvailable = true;
    this.actionItemAttachments = [];
    this.loadAttachments(attachment);
  }

  openAttachmentModal(event:any)
  {
    this.attachmentsAvailable = event;
  }

  private loadAttachments(attachment : ActionItemAttachmentDetails[]){
    this.actionItemAttachments = attachment;
  }

  calculateStatusColor = (status: number) : string => {
    let statusColor = '';
    switch (status) {
      case 0:
        statusColor = 'in_Scheduled ';
        break;
      case 1:
        statusColor = 'in_Pending ';
        break;
      case 2:
        statusColor = 'in_ReadyForVerification';
        break;
      case 3:
        statusColor = 'in_Completed ';
        break;
      case 4:
        statusColor = 'in_Voided';
        break;
      case 5:
        statusColor = 'in_Deferred';
        break;     
    }
    return statusColor;
  }

  SetSpeedDialOptions(actionItem : any) : any{
      this.speedDialOptions = [];
      this.speedDialOptions.push(
          {
              tooltipOptions: {
                  tooltipLabel: "Audit",
                  tooltipPosition: "left",
              },
              icon: 'pi pi-history',
              command: () => {
                  this.openActionItemAuditModal(actionItem.actionItemNumber);
              }
          }
      );

    if(actionItem?.actionItemSpeedDial[ActionItemConstants.ActionItem_SpeedDialButton_VoidedLabel]){ 
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: ActionItemConstants.ActionItem_SpeedDialButton_Void,
            tooltipPosition: "left",
          },
          icon: 'pi pi-ban',
          command: () => {
            this.event = ActionItemConstants.ActionItem_SpeedDialButton_Void;
            this.eventType = ActionItemConstants.ActionItem_Update_StatusUpdate;
            this.preFilledReason = '';
            this.OpenUpdateActionItemModal(); // Construct Modal data
            this.actionItemData = actionItem;
          }
        }
      );
    }

    if(actionItem?.actionItemSpeedDial[ActionItemConstants.ActionItem_SpeedDialButton_DefferedLabel]){
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: ActionItemConstants.ActionItem_SpeedDialButton_Defer,
            tooltipPosition: "left",
          },
          icon: 'pi pi-forward',
          command: () => {
            this.event = ActionItemConstants.ActionItem_SpeedDialButton_Defer;
            this.eventType = ActionItemConstants.ActionItem_Update_StatusUpdate;
            this.preFilledReason = '';
            this.OpenUpdateActionItemModal(); // Construct Modal data
            this.actionItemData = actionItem;
          }
        }
      );
    }

    if(actionItem?.actionItemSpeedDial[ActionItemConstants.ActionItem_SpeedDialButton_Reject]){
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: ActionItemConstants.ActionItem_SpeedDialButton_Reject,
            tooltipPosition: "left",
          },
          icon: 'pi pi-times',
          command: () => {
            this.event = ActionItemConstants.ActionItem_SpeedDialButton_Reject;
            this.eventType = ActionItemConstants.ActionItem_Update_StatusUpdate;
            this.preFilledReason = '';
            this.OpenUpdateActionItemModal(); // Construct Modal data
            this.actionItemData = actionItem;
          }
        }
      );
    }

    if(actionItem?.actionItemSpeedDial[ActionItemConstants.ActionItem_SpeedDialButton_Verify]){
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: ActionItemConstants.ActionItem_SpeedDialButton_Verify,
            tooltipPosition: "left",
          },
          icon: 'pi pi-thumbs-up',
          command: () => {
            this.event = ActionItemConstants.ActionItem_SpeedDialButton_Verify;
            this.eventType = ActionItemConstants.ActionItem_Update_StatusUpdate;
            this.preFilledReason = actionItem?.verifierNotes;
            this.OpenUpdateActionItemModal(); // Construct Modal data
            this.actionItemData = actionItem;
          }
        }
      );
    }

    if(actionItem?.actionItemSpeedDial[ActionItemConstants.ActionItem_SpeedDialButton_Complete]){
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: ActionItemConstants.ActionItem_SpeedDialButton_Complete,
            tooltipPosition: "left",
          },
          icon: 'pi pi-check',
          command: () => {
            this.event = ActionItemConstants.ActionItem_SpeedDialButton_Complete;
            this.eventType = ActionItemConstants.ActionItem_Update_StatusUpdate;
            this.preFilledReason = actionItem?.actionTaken; // Pre filled reason data in modal for Phase Change
            this.OpenUpdateActionItemModal(); // Construct Modal data
            this.actionItemData = actionItem;
          }
        }
      );
    }

    if(actionItem?.actionItemSpeedDial[ActionItemConstants.ActionItem_SpeedDialButton_Edit]){
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: ActionItemConstants.ActionItem_SpeedDialButton_Edit,
            tooltipPosition: "left",
          },
          icon: 'pi pi-pencil',
          command: () => {
            this.event = ActionItemConstants.ActionItem_SpeedDialButton_Edit;
            this.actionItemData = actionItem;
            this.openActionItemSlider();
          }
        }
      );
    }

    if(actionItem?.actionItemSpeedDial[ActionItemConstants.ActionItem_SpeedDialButton_EditForAssignee]){
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: ActionItemConstants.ActionItem_SpeedDialButton_Edit,
            tooltipPosition: "left",
          },
          icon: 'pi pi-pencil',
          command: () => {
            this.event = ActionItemConstants.ActionItem_SpeedDialButton_EditForAssignee;
            this.actionItemData = actionItem;
            this.openActionItemSlider();
          }
        }
      );
    }
    return this.speedDialOptions;
  }

  OpenUpdateActionItemModal(){
    var actionItemModal = this.injector.get<ActionItemModal>(LabelMap.get(this.event));
    this.actionItemLifeCycleModalValues = actionItemModal.getModalValues();
    this.isUpdateActionItemModalOpen = true;  // open the Modal - by passing required Information
  }

  // Event catch to close the reason Dialogue
  closeReasonDialogue(data: any){   
    this.event = ''; // reset event name on close of reason Modal
    this.isUpdateActionItemModalOpen = false;
    this.ActionPlanDataReload(true);
  }

  ActionPlanUpdated(actionPlanData: ActionPlanDetails){
    this.spinnerService.show();
    if(actionPlanData!=null)
    {
      this.ActionPlanData.lists =  actionPlanData?.actionItemDetails;
      this.noData = this.commonService.IsListEmpty(this.ActionPlanData.lists);
      this.SetSelectedItems();
    }
    this.isActionPlanDataAvailable = true;
    this.spinnerService.hide();
    this.changeDetectorRef.detectChanges();
    this.isUpdateActionItemModalOpen = false;
    this.ActionPlanDataReload(true);
  }
  
  openActionItemAuditModal = (actionItemNumber: string) => {
    this.actionItemNumberForAudit = actionItemNumber;
    this.showActionItemAuditModal = true;
  }
  closeActionItemAuditModal = (isModalOpen: boolean) => {
    this.actionItemNumberForAudit = '';
    this.showActionItemAuditModal = isModalOpen;
  }

  updatedActionPlan(data: any) {
    this.ActionPlanUpdated(data);
  }

  updateScopesOnChangeControlUpdate(scopes: number[] | null){
    if(scopes != null)
      this.scopes = scopes;
  }

  
}
